import * as  React from 'react';
import PopupButton from './PopupButton';
import { cancelButtonClass } from '../../../const/popupButtonClasses';

type PopupCancelButtonProps = {
    label: string;
    action: () => void;
}

export default function PopupCancelButton({ label, action }: PopupCancelButtonProps) {
    return <PopupButton
        className={cancelButtonClass}
        label={label || 'Cancel'}
        action={action} />;
}